import {
  ReorderRailCard,
  ReorderRailContainer,
  ReorderRailHeader,
  ReorderRailHeading,
  ReorderRailList,
  ReorderRailSeeAll,
} from './components';

export const ReorderRail = {
  Container: ReorderRailContainer,
  Header: ReorderRailHeader,
  Heading: ReorderRailHeading,
  SeeAll: ReorderRailSeeAll,
  List: ReorderRailList,
  Card: ReorderRailCard,
};
